import React, { useState } from "react";
import {
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { POST } from "../../api/ApiService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EncryptionHelper from "../../shared/EncryptionHelper";

const viewOptions = [
  { label: "Case Received", value: "received" },
  { label: "Cases Assigned", value: "assigned" },
  { label: "Cases Waitlisted", value: "waitlisted" },
];

export default function ReportsPage() {
  const [view, setView] = useState("received");
  const [startDate, setStartDate] = useState(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState(dayjs().endOf("month"));
  const [query, setQuery] = useState("");

  const buildQuery = async () => {
    const baseQuery = `SELECT * FROM \`case\` WHERE ReceivedDate >= '${startDate.format(
      "YYYY-MM-DD"
    )}' AND ReceivedDate <= '${endDate.format("YYYY-MM-DD")}'`;
    let fullQuery = baseQuery;

    if (view === "assigned") {
      fullQuery += " AND AssignedToUserID IS NOT NULL";
    } else if (view === "waitlisted") {
      fullQuery += " AND AssignedToUserID IS NULL";
    }

    setQuery(fullQuery);

    const postData = {
      view,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    };

    const encryptData = EncryptionHelper.encryptData(postData);

    POST("case/run-case-report", { encryptData })
      .then((response) => {
        //console.log('Query results:', response?.message);
        const encryptedData = response?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);
        console.log("decryptedData =>", decryptedData);
        setQuery(decryptedData);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.errors);
      });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 4 }}>
        <Typography variant="h4" mb={3}>
          Reports
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Select
            value={view}
            onChange={(e) => setView(e.target.value)}
            sx={{ minWidth: 200 }}
          >
            {viewOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>

          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />

          <DatePicker
            label="End Date"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />

          <Button variant="contained" onClick={buildQuery}>
            Go
          </Button>
        </Box>

        {query != null && (
          <Box mt={4}>
            <Typography variant="h6">Number of Cases found:</Typography>
            <Box
              sx={{ backgroundColor: "#f5f5f5", p: 2, borderRadius: 2, mt: 1 }}
            >
              <Typography
                variant="body2"
                component="pre"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {query}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </LocalizationProvider>
  );
}
